import { render, staticRenderFns } from "./formEditCompany.vue?vue&type=template&id=db29a502"
import script from "./formEditCompany.vue?vue&type=script&lang=js"
export * from "./formEditCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db29a502')) {
      api.createRecord('db29a502', component.options)
    } else {
      api.reload('db29a502', component.options)
    }
    module.hot.accept("./formEditCompany.vue?vue&type=template&id=db29a502", function () {
      api.rerender('db29a502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/companies/components/form/formEditCompany.vue"
export default component.exports